module.exports = __webpack_public_path__ + "img/pub_rec_deets_mobile_600.0ab2b58f.png";